import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, InputGroup, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { categoryCounts, recentPosts, getCategoryName } from "../data/posts";

function Sidebar() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <aside>
      {/* Search */}
      <div className="widget">
        <h4 className="widget-title">Search</h4>
        <div className="widget-body">
          <Form onSubmit={submit}>
            <InputGroup>
              <Form.Control
                placeholder="Search…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
              <Button type="submit" className="btn-brand">
                <FaSearch />
              </Button>
            </InputGroup>
          </Form>
        </div>
      </div>

      {/* Ad placeholder */}
      {/* <div className="widget">
        <div className="widget-body">
          <div className="ad-box mb-0">Advertisement</div>
        </div>
      </div> */}

      {/* Recent posts */}
      <div className="widget">
        <h4 className="widget-title">Recent Posts</h4>
        <div className="widget-body">
          {recentPosts.slice(0, 5).map((p) => (
            <div className="recent-item" key={p.id}>
              <span
                className="recent-dot"
                style={{ background: p.color }}
                aria-hidden="true"
              />
              <div>
                <Link to={`/post/${p.slug}`} className="rt d-block">
                  {p.title.length > 52 ? p.title.slice(0, 52) + "…" : p.title}
                </Link>
                <span className="rd">{p.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Categories */}
      <div className="widget">
        <h4 className="widget-title">Categories</h4>
        <div className="widget-body">
          <div className="cat-list">
            {categoryCounts.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`}>
                <span>{getCategoryName(c.slug)}</span>
                <span className="count">{c.count}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Pages */}
      <div className="widget">
        <h4 className="widget-title">Pages</h4>
        <div className="widget-body">
          <div className="cat-list">
            <Link to="/about"><span>About Us</span></Link>
            <Link to="/contact"><span>Contact Us</span></Link>
            <Link to="/disclaimer"><span>Disclaimer</span></Link>
            <Link to="/privacy"><span>Privacy Policy</span></Link>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
